import { render, staticRenderFns } from "./CreateBuyer.vue?vue&type=template&id=72bcb3d7&"
import script from "./CreateBuyer.vue?vue&type=script&lang=js&"
export * from "./CreateBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports